import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { routerInstance } from "./routes";
import AuthContextProvider from "./core/contexts/AuthContext";
import AppContextProvider from "./core/contexts/AppContext";
import "./core/styles/index.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const client = new QueryClient();
const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  //<React.StrictMode>
  <AuthContextProvider>
    <QueryClientProvider client={client}>
      <AppContextProvider>
        <RouterProvider router={routerInstance} />
      </AppContextProvider>
    </QueryClientProvider>
  </AuthContextProvider>
  //</React.StrictMode>
);

